export const DELIVERY_CHALLAN_TRANSACTION_REQUEST = 'DELIVERY_CHALLAN_TRANSACTION_REQUEST';
export const DELIVERY_CHALLAN_TRANSACTION_REQUEST_FAILURE = 'DELIVERY_CHALLAN_TRANSACTION_REQUEST_FAILURE';
export const GET_DELIVERY_CHALLAN_TRANSACTIONS_TAKA_NO = 'GET_DELIVERY_CHALLAN_TRANSACTIONS_TAKA_NO';
export const GET_DELIVERY_CHALLAN_TRANSACTIONS = 'GET_DELIVERY_CHALLAN_TRANSACTIONS';